export default __webpack_public_path__ + "static/media/051-is less than.ed360c08.svg";